"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./lib/index"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/mac/PlayGround/~/ngx-color-picker/dist/index.js
// module id = ../../../../ngx-color-picker/dist/index.js
// module chunks = 4